module.exports = __webpack_public_path__ + "static/media/AbandonedTicket.1b6d81d2.svg";